import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { CustomerDto } from '@proxy/dto-common-website/customers';
import { CiamService } from 'src/app/_services/ciam.service';
import { StorageService } from 'src/app/_services/storage.service';
import { UserStore } from 'src/app/store/user.store';
import { MODAL, ModalService } from 'src/app/modals/modal.service';
import { Context } from 'src/app/utils/context';
import { CustomerService } from 'src/publicproxy/src/proxy/public/customer';
import { UpdateCustomerMarketingConsentKfDto } from '../../../../publicproxy/src/proxy/kingfisher-api/models';
import { CardFormCreatorService, StatusEnum } from '../../../_services/card-form-creator.service';
import { SmallUpdateCustomerDto } from './../../../proxy/dto-common-website/customers/models';
import { catchError, debounceTime, distinctUntilChanged, EMPTY, filter, finalize, Subject, switchMap, take, takeUntil } from 'rxjs';

@Component({
  selector: 'ng-casto-customer-informations',
  templateUrl: './customer-informations.component.html'
})
export class CustomerInformationsComponent implements OnInit, OnDestroy {

  personalInformationsForm!: FormGroup;
  isEmailSearched: boolean = true;
  loading: boolean = false;
  saveLoading: boolean;

  private readonly modalService = inject(ModalService);
  private readonly customerService = inject(CustomerService);
  private readonly storageService = inject(StorageService);
  private readonly cardFormCreatorService = inject(CardFormCreatorService);
  private readonly ciamService = inject(CiamService);
  private readonly userStore = inject(UserStore);

  private readonly destroy$ = new Subject<void>();

  ngOnInit() {
    this.loading = true;
    this.customerService.getCustomer()
      .pipe(
        take(1),
        finalize(() => this.loading = false)
      )
      .subscribe({
        next: (customer: CustomerDto) => {
          this.personalInformationsForm = this.cardFormCreatorService.createForm(StatusEnum.SmallUpdate, Context.Customer, customer);

          const marketingConsentForm = this.personalInformationsForm.get('marketingConsent');
          marketingConsentForm.valueChanges
            .pipe(
              filter(() => marketingConsentForm.dirty),
              debounceTime(1000),
              distinctUntilChanged(),
              switchMap(marketingConsent => {
                const updateCustomerMarketingConsentKfDto: UpdateCustomerMarketingConsentKfDto = {
                  customerIdKf: customer.id,
                  marketingConsent: marketingConsent
                };

                return this.customerService.updateMarketingConsentCustomer(updateCustomerMarketingConsentKfDto)
                  .pipe(catchError(err => { console.error(err); return EMPTY; }));
              }),
              takeUntil(this.destroy$)
            ).subscribe();
        },
        error: err => console.error(err)
      });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  submitForm(): void {
    this.saveLoading = true;

    // `getRawValue()` et non `value` : sur le site customer, l'adresse mail est l'identité CIAM,
    // donc un contrôle désactivé — que `value` omettrait. Le contrat l'exige, et Cheetah en a
    // besoin. Même lecture que le formulaire de création de carte.
    const customerDto: SmallUpdateCustomerDto = {
      customerIdKf: this.storageService.getUser(),
      ...this.personalInformationsForm.getRawValue()
    };

    this.customerService.smallUpdateCustomer(customerDto).subscribe({
      next: () => {
        this.userStore.patchCustomer({ firstName: customerDto.firstName, name: customerDto.lastName });

        this.modalService.display(MODAL.SUCCESS, {
          title: 'Informations mises à jour',
          message: 'Vos informations ont bien été mises à jour.'
        });

        this.saveLoading = false;
      },
      error: (err) => {
        console.error(err);
        this.saveLoading = false;
      }
    });
  }

  openPasswdModal(): void {
    this.ciamService.redirectToForgotPassword('/informations');
  }
}
